import { useState } from 'react'
import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { OperatorGroupPermission } from '@/schema'
import useQueryGetPlayerTags from '../../api/hooks/useQueryGetPlayerTags'
import PlayerTagsListing from '../../components/PlayerTagsListing'
import CreatePlayerTagModal from '../../components/PlayerTagsListing/components/CreatePlayerTagModal'

function PlayerTagsPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		search: searchQuery || undefined,
	}

	const { data, isLoading, refetch } = useQueryGetPlayerTags(payload)

	const handleCreateTag = () => {
		setIsCreateModalOpen(true)
	}

	const handleRefetch = () => {
		refetch()
	}

	return (
		<PageContainer>
			<PlayerTagsListing
				data={data || []}
				total={data?.length || 0}
				isLoading={isLoading}
				onCreateTag={handleCreateTag}
				onRefetch={handleRefetch}
			/>

			<CreatePlayerTagModal
				open={isCreateModalOpen}
				onOpenChange={setIsCreateModalOpen}
			/>
		</PageContainer>
	)
}

const GuardedPlayerTagsPage = withUserPermission(PlayerTagsPage, {
	permissionType: PermissionType.Read,
	permissionKey: [OperatorGroupPermission.MANAGE_PLAYER_TAGS],
})

export default GuardedPlayerTagsPage
